module.exports = [
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Oppstarts sett",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono startsett: søylekran for filtrert, avkjølt og karbonert vann. Inkluderer kjøler, filter og CO2-flaske. Høy C-tut, kromfinish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Oppstarts sett",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono startsett: søylekran for filtrert, avkjølt og karbonert vann. Inkluderer kjøler, filter og CO2-flaske. Høy C-tut, finish i rustfritt stål.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tut Oppstartssett",
		"textblock_1st_text": "31454000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tut Oppstartssett",
		"textblock_1st_text": "31454DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tut Oppstartssett",
		"textblock_1st_text": "31455000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-tut Oppstartssett",
		"textblock_1st_text": "31455DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tut Oppstartssett",
		"textblock_1st_text": "31456000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-tut Oppstartssett",
		"textblock_1st_text": "31456DC0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kjøkkenkran og M-størrelse bereder",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "GROHE RED Mono kjøkkenkran (L-tut) med filtersett og M-bereder for kokende vann i en håndvending. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i M-størrelse",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (L-tut) med filtersett og bereder i M-størrelse for kokende vann rett fra kranen. Matt finish i rustfritt stål. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i M-størrelse",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (L-tut) med filtersett og M-bereder for kokende vann i en håndvending. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i L-størrelse",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (L-tut) med filtersett og bereder i L-størrelse for kokende vann rett fra kranen. Matt finish i rustfritt stål. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i L-størrelse",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (L-tut) med filtersett og L-bereder for kokende vann i en håndvending. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Blandeventil",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kjøkkenkran og M-størrelse bereder",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono kjøkkenkran (C-tut) med filtersett og bereder i M-størrelse for kokende vann rett fra kranen. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i M-størrelse",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (C-tut) med filtersett og bereder i M-størrelse for kokende vann rett fra kranen. Matt finish i rustfritt stål. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i M-størrelse",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (C-tut) med filtersett og M-bereder for kokende vann i en håndvending. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Kjøkkenkran og L-størrelse bereder",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono kjøkkenkran (C-tut) med filtersett og L-bereder for kokende vann i en håndvending. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i L-størrelse",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (C-tut) med filtersett og bereder i L-størrelse for kokende vann rett fra kranen. Matt finish i rustfritt stål. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kjøkkenbatteri og bereder i L-størrelse",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Duo kjøkkenkran (C-tut) med filtersett og bereder i L-størrelse for kokende vann rett fra kranen. Kromfinish. Best mulig energieffektivitet og sikkerhetsfunksjoner.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.no/no_no/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.no/no_no/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_no_no.json
// module id = 889
// module chunks = 0